'use client';
import BDImage from '@shared/components/elements/bd-image';
import BDVideo from '@shared/components/elements/bd-video';
import { ExternalVideo, RingImage, RingVideo } from '@shared/lib/shopify/types/shopify-native';
import { StaticImageData } from 'next/image';
import React from 'react';
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

interface ImageCarouselProps {
  video?: RingVideo | ExternalVideo;
  images: RingImage[] | StaticImageData[];
  selectedItem: number;
  buttonClassName?: string;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  video,
  images,
  selectedItem = 0,
  buttonClassName,
}) => {
  return (
    <Carousel
      showArrows={true}
      autoPlay={true}
      interval={6000}
      infiniteLoop={true}
      showThumbs={false}
      showStatus={false}
      selectedItem={selectedItem}
      renderArrowPrev={(onClickHandler, hasPrev, _label) =>
        hasPrev && (
          <button
            type="button"
            onClick={onClickHandler}
            className={`absolute left-4 top-1/2 z-10 -translate-y-1/2 transform cursor-pointer rounded-full text-4xl text-slate-500 opacity-50 hover:opacity-100 ${buttonClassName}`}
          >
            <IoIosArrowDropleftCircle />
          </button>
        )
      }
      renderArrowNext={(onClickHandler, hasNext, _label) =>
        hasNext && (
          <button
            type="button"
            onClick={onClickHandler}
            className={`absolute right-4 top-1/2 -translate-y-1/2 transform cursor-pointer rounded-full text-4xl text-slate-500 opacity-50 hover:opacity-100 ${buttonClassName}`}
          >
            <IoIosArrowDroprightCircle />
          </button>
        )
      }
    >
      {
        [
          video && <BDVideo key={video.url} video={video} className="h-full w-full" />,
          ...images.map((image, index) => (
            <div key={index} className="relative h-full overflow-hidden bg-gray-200">
              <BDImage src={image} className="h-full w-full object-cover object-center" />
            </div>
          )),
        ].filter(Boolean) as React.ReactNode[]
      }
    </Carousel>
  );
};

export default ImageCarousel;
